// extracted by mini-css-extract-plugin
export var dataCell = "_jc-2";
export var dataRow = "_jc-0";
export var headerRow = "_jc-1";